import { render, staticRenderFns } from "./productType.vue?vue&type=template&id=8974599e&scoped=true"
import script from "./productType.vue?vue&type=script&lang=js"
export * from "./productType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8974599e",
  null
  
)

export default component.exports